import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../../../Table/Table.css';

const StyledCellLink = ({
  path,
  text,
  from,
  primaryLink,
  enabled,
  onClick
}) => {
  if (!enabled) {
    return (
      <span title={text} className="underlink disabled">
        {text}
      </span>
    );
  }

  return (
    <Link
      title={text}
      to={{
        pathname: path,
        state: { from }
      }}
      className={primaryLink ? 'link' : 'underlink'}
        onClick={onClick}
    >
      {text}
    </Link>
  );
};

StyledCellLink.propTypes = {
  path: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  enabled: PropTypes.bool,
  onClick: PropTypes.func,
  primaryLink: PropTypes.bool
};

StyledCellLink.defaultProps = {
  primaryLink: false,
  onClick: () => {},
  enabled: true
};

export default StyledCellLink;
